/* eslint-disable max-len */
import React, { Fragment } from 'react'
import TableBody from './TableBody'
import { useOnClickOutside } from '../../../../../../CommonMethods/OutsideClick';
import { useState,useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { selectAllRows } from '../../../../../../redux/MultiselectRows';
import { useSelector ,useDispatch} from 'react-redux';
import SearchEmptyScreen from '../../../../../../components/SearchEmptyScreen';

const OrgUserExportTable=({pageNumber,List,handleSearchParams,sortValue,setisSortSelected,setConfirmationState,setTextAreaMsg})=>{
    const [searchParams,setSearchParams]=useSearchParams()
    const [selectedIndex, setSelectedIndex] = useState(null); 
    const selectedRef = useRef();
    const selectedRows=useSelector((state)=>state?.MultiSelectSlice?.selectedRows)
    const urlParams = new URLSearchParams(window.location.search);
    useOnClickOutside(selectedRef, () => {
        setSelectedIndex(null)
    });
    return(
        <div>
            <div className='pagination_bottom_history h-[calc(100vh-270px)] 2xl:h-[calc(100vh-270px)] overflow-auto scrollbar_purple pb-2.5' onScroll={()=>setSelectedIndex('')}>
                <table aria-label="Outside Table" className="w-full table-auto">
                    <thead>
                        <tr className="h-[38px] w-full bg-[#EDD7E1] rounded-sm sticky top-0 left-0 z-[1]">
                            <th className="px-[9px] py-2 min-w-[100px] rounded-tl-sm rounded-bl-sm">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Username
                                </span>
                            </th>
                            <th className="px-[9px] py-2 min-w-[178px]"  >
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Time Stamp
                                </span>
                            </th>
                            <th className="px-[9px] py-2 min-w-[200px]">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Action Performed
                                </span>
                            </th>
                            <th className="px-[9px] py-2 min-w-[165px]" >
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Field
                                </span>
                            </th>
                            <th className="px-[9px] py-2 min-w-[180px]">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Old Value
                                </span>
                            </th>
                            <th className="px-[9px] py-2 min-w-[200px]">
                                <span className="flex items-center text-sm font-normal text-[#000000]">New Value
                                </span>
                            </th>
                            <th className="px-[9px] py-2 min-w-[200px] rounded-tl-sm rounded-bl-sm">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000] ">Comments
                                </span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {List?.data?.map((item,index)=>(
                            <Fragment key={item._id}>
                                <TableBody
                                    tableData={item}
                                    List={List}
                                    indexNum={index}
                                    pageNumber={pageNumber}
                                    selectedIndex={selectedIndex}
                                    setSelectedIndex={setSelectedIndex}
                                    selectedRef={selectedRef}
                                    lastIndex={List?.data?.length}
                                    setConfirmationState={setConfirmationState}
                                    setTextAreaMsg={setTextAreaMsg}
                                />
                            </Fragment>
                        ))}
                        
        
                    </tbody>
                    
                </table>

            </div>
        </div>
    )
}

export default OrgUserExportTable;